<template>
  <div class="confirm">
    <div class="confirm-mask" :class="{ show }"></div>
    <div class="confirm-content" :class="{ show, scale }">
      <div class="confirm-data">
        <div
          v-if="status && statusTitle"
          class="confirm-status"
          :class="{ [status]: status }"
        >
          <div class="confirm-status-icon"></div>
          <div class="confirm-status-text">{{ statusTitle }}</div>
        </div>
        <div v-if="title" class="confirm-title">{{ title }}</div>
        <div v-if="content" class="confirm-text">{{ content }}</div>
      </div>
      <div class="confirm-btn-bar">
        <div
          v-for="(item, index) in btns"
          :key="index"
          :style="{ color: item.color }"
          @click="btnClick(item, $event)"
          class="confirm-btn"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "confirm",
  props: {
    title: String,
    content: String,
    appender: Object,
    status: String,
    statusTitle: String,
    btns: {
      type: Array,
      default: function() {
        return [
          {
            name: "我知道了",
            key: "close",
            color: "#00B9EF",
          },
        ];
      },
    },
    onClick: {
      type: Function,
      default: function() {
        this.appender &&
          typeof this.appender.close === "function" &&
          this.appender.close();
      },
    },
  },
  mounted() {},
  data() {
    return {
      show: false,
      scale: true,
    };
  },
  methods: {
    open() {
      this.scale = true;
      this.$nextTick((_) => (this.show = true));
    },
    close(callback) {
      this.scale = false;
      this.$nextTick((_) => {
        this.show = false;
        setTimeout((_) => {
          typeof callback === "function" && callback();
        }, 260);
      });
    },
    btnClick(item, ev) {
      this.onClick(Object.assign({}, item), ev);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/common/scss/base";
.confirm-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 150ms ease-in-out;
}
.confirm-mask.show {
  opacity: 1;
  visibility: visible;
}
.confirm-content.scale {
  transform: translate(-50%, -50%) scale(0.6, 0.6);
}
.confirm-content.show {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -50%) scale(1, 1);
}
.confirm-content {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  background-color: white;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #181a24;
  width: 540px;
  background: #ffffff;
  border-radius: 20px;
  text-align: center;
  visibility: hidden;
  opacity: 0;
  transition: all 200ms ease-in-out;
  .confirm-data {
    width: 100%;
    padding: 30px 30px 36px;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    .confirm-status {
      margin-top: 30px;
      .confirm-status-icon {
        margin: 0 auto;
        width: 60px;
        height: 60px;
      }
      .confirm-status-text {
        margin-top: 12px;
        font-size: 32px;
        line-height: 56px;
        letter-spacing: 1px;
      }
      &.error {
        .confirm-status-icon {
          background: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210615101123350-icon_common_statusIcon@3x.png) no-repeat center center/contain;
        }
        .confirm-status-text {
          color: #ec5042;
        }
      }
    }
    .confirm-status+.confirm-title,.confirm-status+.confirm-text {
      margin-top: 30px;
    }
    .confirm-title {
      font-size: 32px;
      line-height: 56px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .confirm-text {
      font-size: 28px;
      line-height: 48px;
      white-space: pre-wrap;
      text-align: left;
    }
  }
  .confirm-btn-bar {
    display: flex;
    align-items: center;
    .confirm-btn {
      flex: 1 0;
      padding: 24px 0;
      font-size: 30px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #747a86;
      line-height: 52px;
      text-align: center;
    }
  }

  .confirm-title + .confirm-text {
    margin-top: 10px;
  }
}
</style>
